import { Outlet } from 'react-router-dom'

/**
 * Section shells.
 *
 * ── Why these are bare outlets ──
 * Each of these used to render a row of tabs above its <Outlet> — the section's pages as a
 * second navigation control. Those tabs listed routes the left rail already lists in full,
 * so every destination had two controls and two active states. The rail is the app's single
 * navigation surface now; see the note on the app bar in AppShell.tsx.
 *
 * They stay as three named components rather than collapsing into one so the route table
 * keeps reading as three sections, and so a section that later needs state shared across its
 * pages has somewhere to put it.
 */

export function EarnSection() {
  return <Outlet />
}

export function LendSection() {
  return <Outlet />
}

export function NdxSection() {
  return <Outlet />
}
